export interface Config {
  // urlPath: string;
  baseUrlAxios: string;
  captchaSiteKey: string;
}

export const myConfig: Config = {
  // urlPath: "192.168.0.119",
  baseUrlAxios: "http://localhost:5000",
  captchaSiteKey: "6LdhmSUkAAAAAGhbEfpJ3Dvhdh-51LoVh6QfvAWK",
};
